/**
 * Vertical bar chart for distribution data.
 * Wraps Recharts BarChart with rounded top corners and rotated labels.
 */

import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

type BarItem = { readonly name: string; readonly value: number };

type Props = {
  readonly data: ReadonlyArray<BarItem>;
  readonly color?: string;
  readonly height?: number;
};

const DEFAULT_COLOR = "#111";
const DEFAULT_HEIGHT = 240;
const AXIS_STYLE = { fontSize: 12 } as const;
const BAR_RADIUS: [number, number, number, number] = [4, 4, 0, 0];

const TOOLTIP_STYLE: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid var(--color-border)",
  borderRadius: 6,
  padding: "8px 12px",
  fontSize: 13,
};

export function BarDistribution({
  data,
  color,
  height,
}: Props): React.JSX.Element {
  const barColor = color ?? DEFAULT_COLOR;
  const chartHeight = height ?? DEFAULT_HEIGHT;

  return (
    <ResponsiveContainer width="100%" height={chartHeight}>
      <BarChart data={data as BarItem[]}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" tick={AXIS_STYLE} angle={-20} />
        <YAxis tick={AXIS_STYLE} />
        <Tooltip contentStyle={TOOLTIP_STYLE} />
        <Bar dataKey="value" fill={barColor} radius={BAR_RADIUS} />
      </BarChart>
    </ResponsiveContainer>
  );
}
